<template>
    <div
        class="border border-ewhite-200 rounded-xl px-5 hover:border-eorange-500/50 bg-white transition-all duration-300 hover:shadow-lg hover:shadow-eorange-500/[0.02] group"
    >
        <button
            class="flex items-center justify-between gap-4 py-4 text-left text-sm font-semibold transition-all outline-none text-eblack-900 hover:text-eorange-500 w-full font-modulus focus:outline-none"
            @click="toggle"
            :aria-expanded="isOpen.toString()"
        >
            <div class="flex items-center space-x-3.5">
                <div v-html="svg" class="bg-eorange-500/10 p-2.5 rounded-xl group-hover:bg-eorange-500/20 text-eorange-500 transition-colors duration-300 shrink-0">
                </div>
                <span class="font-bold text-eblack-900 group-hover:text-eorange-600 transition-colors duration-300">{{ title }}</span>
            </div>
            <IconCircleArrowDown
                stroke-width="2"
                :class="['text-eblack-400 group-hover:text-eorange-500 pointer-events-none size-5 shrink-0 transition-all duration-300', isOpen ? 'rotate-180 text-eorange-500' : '']"
            />
        </button>

        <div
            ref="contentArea"
            :style="isOpen ? { maxHeight: contentHeight + 'px', opacity: 1 } : { maxHeight: '0px', opacity: 0 }"
            class="text-eblack-600 overflow-hidden text-sm transition-all duration-300 ease-in-out px-1"
        >
            <div class="pb-4 pt-1 text-eblack-500 leading-relaxed font-modulus">
                {{ content }}
            </div>
        </div>
    </div>
</template>

<script>
import { IconCircleArrowDown } from '@tabler/icons-vue';

export default {
    props: ['svg', 'title', 'content'],
    name: 'AccordionItem',
    components: {
        IconCircleArrowDown
    },
    data() {
        return {
            isOpen: false,
            contentHeight: 0
        };
    },
    mounted() {
        // Listen to window resize to update height if needed
        window.addEventListener('resize', this.updateHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateHeight);
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
            this.updateHeight();
        },
        updateHeight() {
            if (this.isOpen) {
                this.$nextTick(() => {
                    const el = this.$refs.contentArea;
                    this.contentHeight = el ? el.scrollHeight : 500;
                });
            } else {
                this.contentHeight = 0;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>